module.exports = __webpack_public_path__ + "static/media/esvaziandoDreno.6dac85ba.jpg";